import React from "react";

export default function Mac({ className, onClick, style }) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.0504 2.0765H2.89448C1.93534 2.0765 1.15779 2.85404 1.15779 3.81319V17.1278H27.7871V3.81319C27.7871 2.85404 27.0095 2.0765 26.0504 2.0765ZM1.15779 19.7329V18.2856H27.7871V19.7329C27.7871 20.692 27.0095 21.4695 26.0504 21.4695H2.89449C1.93534 21.4695 1.15779 20.692 1.15779 19.7329ZM2.89448 0.918701C1.29591 0.918701 0 2.21461 0 3.81319V19.7329C0 21.3314 1.29591 22.6273 2.89449 22.6273H10.5549C10.6304 23.329 10.7096 24.1778 10.7096 24.6535C10.7096 25.1511 9.93002 26.0571 9.22378 26.7758C8.84888 27.1573 9.11307 27.8374 9.64793 27.8374H19.297C19.8318 27.8374 20.096 27.1573 19.7211 26.7758C19.0149 26.0572 18.2353 25.1511 18.2353 24.6535C18.2352 24.1778 18.3144 23.329 18.3899 22.6273H26.0504C27.6489 22.6273 28.9448 21.3314 28.9448 19.7329V3.81319C28.9448 2.21461 27.6489 0.918701 26.0504 0.918701H2.89448Z"
        fill="inherit"
      />
    </svg>
  );
}
